const PUBLIC_URL = process.env.PUBLIC_URL;

export class ServicesAudio {

  static async getDatos(fecha_inicio, fecha_fin, categorias, programas, protagonistas, texto) {

    const datos = [
      {
        key: '1',
        fecha: '06/03/2025',
        programa: 'DE LA NOCHE AL DIA',
        categorias: ['Tertulia', 'Actualidad', 'Noticias', 'Música'],
        audio: PUBLIC_URL + "/DE LA NOCHE AL DIA 63000 04092025.mp3",
        transcripcion: PUBLIC_URL + "/DE LA NOCHE AL DIA 63000 04092025.json",
        protagonistas: ['Estíbaliz Pérez', 'Rita Hernández', 'Lara Carrascosa', 'Leopoldo Fernández', 'Jose Luis']
      },
      {
        key: '2',
        fecha: '16/03/2025',
        programa: 'DE LA NOCHE AL DIA',
        categorias: ['Actualidad', 'Noticias'],
        audio: PUBLIC_URL + "/DE LA NOCHE AL DIA 80000 04092025.mp3",
        transcripcion: PUBLIC_URL + "/DE LA NOCHE AL DIA 80000 04092025.json",
        protagonistas: ['Estíbaliz Pérez', 'Jorge Marichal', 'Rubén Sánchez', 'Matilde Asian', 'Fernando Clavijo']
      },
      {
        key: '3',
        fecha: '15/04/2025',
        programa: 'EL ANALISIS INTERNACIONAL',
        categorias: ['Noticias', 'Actualidad internacional'],
        audio: PUBLIC_URL + "/EL ANALISIS INTERNACIONAL 040925.mp3",
        transcripcion: PUBLIC_URL + "/EL ANALISIS INTERNACIONAL 040925.json",
        protagonistas: ['Javier Granados', 'Raquel Quiñones', 'Roberto Mancilla']
      },
      {
        key: '4',
        fecha: '29/04/2025',
        programa: 'EL DEPORTIVO TIEMPO EXTRA',
        categorias: ['Deporte'],
        audio: PUBLIC_URL + "/EL DEPORTIVO TIEMPO EXTRA 040925.mp3",
        transcripcion: PUBLIC_URL + "/EL DEPORTIVO TIEMPO EXTRA 040925.json",
        protagonistas: ['Carlos Guillermo Dóminguez', 'Manu Fuster', 'Antonio Morales', 'Antonio Porro']
      },
      {
        key: '5',
        fecha: '01/05/2025',
        programa: 'LA ALPISPA',
        categorias: ['Historia de Canarias', 'Noticias', 'Música'],
        audio: PUBLIC_URL + "/LA ALPISPA 040925.mp3",
        transcripcion: PUBLIC_URL + "/LA ALPISPA 040925.json",
        protagonistas: ['Eugenio González', 'Mercedes Martín', 'Verónica Pérez']
      }
    ];

    // --------------------------
    // Helpers
    // --------------------------

    const parseFecha = (f) => {
      if (!f) return null;
      const [d, m, y] = f.split('/');
      return new Date(y, m - 1, d);
    };

    const parseOffset = (offset) => {
      return offset ? parseFloat(offset.replace("s", "")) : 0;
    };

    const inicio = parseFecha(fecha_inicio);
    const fin = parseFecha(fecha_fin);

    const textoLower = texto?.toLowerCase() || "";
    const protagonistasLower = protagonistas?.map(p => p.toLowerCase()) || [];

    // --------------------------
    // Filtrado básico
    // --------------------------

    let filtrados = datos.filter((item) => {

      const fechaItem = parseFecha(item.fecha);

      if (inicio && fechaItem < inicio) return false;
      if (fin && fechaItem > fin) return false;

      if (categorias?.length) {
        if (!item.categorias.some(c => categorias.includes(c))) return false;
      }

      if (programas?.length) {
        if (!programas.includes(item.programa)) return false;
      }

      if (protagonistas?.length) {
        if (!item.protagonistas.some(p => protagonistas.includes(p))) return false;
      }

      return true;
    });

    const resultadoFinal = [];

    // --------------------------
    // Procesar cada audio
    // --------------------------

    for (const item of filtrados) {

      const res = await fetch(item.transcripcion);
      const json = await res.json();

      const buscarTexto = textoLower !== "";
      const buscarProtagonista = protagonistasLower.length > 0;

      // --------------------------------
      // CASO 1: no hay búsqueda
      // --------------------------------

      if (!buscarTexto && !buscarProtagonista) {

        const first = json.results?.[0];
        const alt = first?.alternatives?.[0];

        if (!alt) continue;

        const transcript = alt.transcript;
        const firstWord = alt.words?.[0];

        resultadoFinal.push({
          ...item,
          startOffset: parseOffset(firstWord?.startOffset),
          frase: transcript
        });

        continue;
      }

      // --------------------------------
      // CASO 2: búsqueda por texto o protagonista
      // --------------------------------

      let encontrado = false;

      for (const result of json.results) {

        if (encontrado) break;

        const alt = result.alternatives?.[0];
        if (!alt) continue;

        const transcript = alt.transcript;
        const transcriptLower = transcript.toLowerCase();

        let matchTexto = false;
        let matchProtagonista = false;

        // Buscar texto
        if (buscarTexto && transcriptLower.includes(textoLower)) {
          matchTexto = true;
        }

        // Buscar protagonistas
        if (buscarProtagonista) {
          matchProtagonista = protagonistasLower.some(p =>
            transcriptLower.includes(p)
          );
        }

        if (matchTexto || matchProtagonista) {

          const primeraPalabra = buscarTexto
            ? textoLower.split(" ")[0]
            : protagonistasLower[0].split(" ")[0];

          const wordMatch = alt.words?.find(w =>
            w.word?.toLowerCase().includes(primeraPalabra)
          );

          resultadoFinal.push({
            ...item,
            startOffset: parseOffset(wordMatch?.startOffset),
            frase: transcript
          });

          encontrado = true;
        }
      }
    }

    return resultadoFinal;
  }
}